import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import { usePdpContext } from '../pdp-provider';
import messages from './messages';

export const Allergens = () => {
  const allergens = usePdpContext().sizeInfo?.selectedSize?.allergens ?? {};
  return (
    <div data-e2e="allergensSection">
      <Heading
        bottomBorder
        className="mb3 text-semibold"
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...messages.allergensTitle} />
      </Heading>
      {allergens.shouldDisplay && allergens.text ? (
        <p className="my1">{allergens.text}</p>
      ) : (
        <p className="my1">
          <FormattedMessage {...messages.nutritionNotAvailable} />
        </p>
      )}
      <div className="color-textBlackSoft mt1 pt3">
        <FormattedMessage {...messages.allergenDisclaimer} />
      </div>
    </div>
  );
};
